import { ChevronDown, ChevronUp, Download, Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { shortLabel } from "./dates";

export default function ResultCard({ result, setResult, openDay, setOpenDay, onSave, saving, savedId, onDownload }) {
  const editSection = (di, label, value) => setResult((r) => ({ ...r, plans: r.plans.map((p, i) => (i === di ? { ...p, sections: { ...p.sections, [label]: value } } : p)) }));
  const first = result.plans[0], last = result.plans[result.plans.length - 1];
  return (
    <div className="hq-glass rounded-2xl p-4 space-y-3" data-testid="lp-result">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div>
          <p className="text-sm text-slate-200" data-testid="lp-result-title">{first.day_label}{result.plans.length > 1 ? ` → ${last.day_label}` : ""}</p>
          <p className="text-[11px] text-muted-foreground">{result.plans.length} day{result.plans.length > 1 ? "s" : ""} · {result.template_name || "Built-in layout"} · {result.labels.length} boxes per day</p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          {savedId ? (
            <>
              {result.plans.map((d, di) => (
                <button key={di} data-testid={`lp-result-dl-${di}`} onClick={() => onDownload(savedId, di)} className="text-xs px-2 h-8 rounded bg-slate-700 text-slate-100 hover:bg-slate-600 inline-flex items-center gap-1"><Download className="w-3.5 h-3.5" /> {shortLabel(d.date)}</button>
              ))}
              {result.plans.length > 1 && <button data-testid="lp-result-dl-week" onClick={() => onDownload(savedId, null)} className="text-xs px-2 h-8 rounded bg-[#22D3EE] text-[#04121f] hover:bg-[#22D3EE]/90 inline-flex items-center gap-1"><Download className="w-3.5 h-3.5" /> Whole week (.docx)</button>}
            </>
          ) : (
            <Button data-testid="lp-save-plan" onClick={onSave} disabled={saving} className="bg-emerald-500 text-[#04121f] hover:bg-emerald-400">
              {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />} Save plan to download
            </Button>
          )}
        </div>
      </div>
      {result.plans.map((day, di) => (
        <div key={di} className="rounded-xl border border-white/10 bg-white/[0.02]">
          <button data-testid={`lp-day-toggle-${di}`} onClick={() => setOpenDay(openDay === di ? -1 : di)} className="w-full flex items-center justify-between px-4 py-2.5 text-left gap-3">
            <span className="min-w-0">
              <span className="block text-sm font-medium text-[#a5b4fc]" data-testid={`lp-result-day-label-${di}`}>{day.day_label}</span>
              <span className="block text-[11px] text-muted-foreground truncate">{day.work}</span>
            </span>
            {openDay === di ? <ChevronUp className="w-4 h-4 text-slate-400 shrink-0" /> : <ChevronDown className="w-4 h-4 text-slate-400 shrink-0" />}
          </button>
          {openDay === di && (
            <div className="px-4 pb-4 space-y-3">
              {day.focus && <p className="text-xs text-slate-300 italic">{day.focus}</p>}
              {result.labels.map((label) => (
                <div key={label}>
                  <label className="text-xs uppercase tracking-widest text-muted-foreground">{label}</label>
                  <textarea data-testid={`lp-section-${di}-${label}`} value={day.sections[label] || ""} onChange={(e) => editSection(di, label, e.target.value)}
                    rows={Math.max(2, Math.min(10, (day.sections[label] || "").split("\n").length + 1))}
                    className="w-full mt-1 rounded-md bg-slate-800 border border-slate-600 px-2.5 py-2 text-sm text-slate-100 outline-none focus:border-[#818CF8] resize-y" />
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
